import { gql } from '@apollo/client';

export * from './removeUser.mutation.generated';

export const REMOVE_USER = gql`
  mutation removeUser($userId: ID!) {
    removeUser(input: { userId: $userId }) {
      success
      errors
    }
  }
`;
